import constants from ".";

const { PREVENTIVA, CORRECTIVA } = constants;

export const adminRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    title: true,
    name: "MENU ADMINISTRADOR"
  },
  {
    name: "CRM",
    url: "/company",
    icon: "fa fa-briefcase",
    children: [
      {
        name: "Empresas",
        url: "/company/list",
        icon: "icon-list"
      }
    ]
  },
  {
    name: "RRHH",
    url: "/rrhh",
    icon: "fa fa-users",
    children: [
      {
        name: "Personal",
        url: "/rrhh/users",
        icon: "icon-list"
      }
    ]
  },
  {
    name: "Pago de variable",
    url: "/payments",
    icon: "fa fa-money"
  },
  {
    name: "Reporte de Estados",
    url: "/requeriments/status_logs",
    icon: "fa fa-file"
  },
  {
    name: "Gestor de flota",
    url: "/fleet",
    icon: "icon-grid",
    children: [
      {
        name: "Proveedores",
        url: "/fleet/providers/list",
        icon: "fa fa-truck"
      },
      {
        name: "Flota",
        url: "/fleet/list",
        icon: "fa fa-truck"
      },
      // {
      //   name: 'Carretas',
      //   url: '/cart/list',
      //   icon: 'fa fa-truck'
      // },
      {
        name: "Combustible",
        url: "/fleet/fuel",
        icon: "fa fa-tint"
      },
      {
        name: "Descuentos",
        url: "/fleet/sinister",
        icon: "fa fa-ambulance"
      }
    ]
  },
  {
    name: "Gestor de zonas",
    url: "/zones",
    icon: "icon-grid",
    children: [
      {
        name: "Zonas",
        url: "/zones/list",
        icon: "fa fa-map-o"
      }
    ]
  },
  {
    name: "Gestor de liquidación",
    url: "/liquidacion",
    icon: "icon-grid",
    children: [
      {
        name: "Liquidación",
        url: "/liquidacion/list",
        icon: "fa fa-info-circle"
      }
    ]
  }
];

export const portPlannerRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    title: true,
    name: "Requerimientos"
  },
  {
    name: "Vacíos",
    url: "/empty_containers",
    icon: "icon-grid"
  },
  {
    name: "Porteo",
    url: "/portage",
    icon: "fa fa-ship",
    children: [
      {
        name: "Calendario (citas)",
        url: "/portage/list"
      },
      {
        name: "Avance",
        url: "/portage/progress"
      }
    ]
  },
  {
    name: "Puertos",
    url: "/ports",
    icon: "fa fa-ship"
  },
  {
    name: "Terminados",
    url: "/portage/finish",
    icon: "icon-drawer"
  },
  {
    name: "Gestor de flota",
    url: "/fleet",
    icon: "icon-grid",
    children: [
      {
        name: "Flota",
        url: "/fleet/list",
        icon: "fa fa-truck"
      },
      {
        name: "Estado de flota",
        url: "/fleet/status",
        icon: "fa fa-truck"
      }
      // {
      //   name: 'Reporte de fallas',
      //   url: '/fleet/incidents',
      //   icon: 'icon-wrench'
      // }
    ]
  },
  {
    name: "Asistencia",
    url: "/assistance",
    icon: "fa fa-calendar-plus-o",
    children: [
      {
        name: "Registro diario",
        url: "/assistance/list"
      },
      {
        name: "Reporte mensual",
        url: "/assistance/report"
      }
    ]
  },
  {
    name: "Mapa",
    url: "/|",
    icon: "icon-location-pin"
  }
];

export const plannerRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    name: "Por aprobar",
    url: "/services/all-pending",
    icon: "icon-pin"
  },
  // {
  //   name: 'Pendientes',
  //   url: '/services/pending',
  //   icon: 'icon-pin'
  // },
  {
    title: true,
    name: "Servicios planta cliente"
  },
  {
    name: "Importaciones",
    url: "/requeriments/import/",
    icon: "icon-arrow-right-circle",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/import/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/import/assigned"
      }
    ]
  },
  {
    name: "Exportaciones",
    url: "/requeriments/export/",
    icon: "icon-globe",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/export/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/export/assigned"
      }
    ]
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/positioning/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/positioning/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/positioning/assigned"
      }
    ]
  },
  {
    name: "Reentregas",
    url: "/voids/redeliveries",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/redeliveries/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/redeliveries/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/redeliveries/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  },
  {
    title: true,
    name: ""
  },
  {
    name: "Por vencer",
    url: "/expiration",
    icon: "fa fa-ship"
  },
  {
    name: "Terminados",
    url: "/requeriments/finish",
    icon: "icon-drawer"
  },
  {
    name: "Gestor de flota",
    url: "/fleet",
    icon: "fa fa-truck",
    children: [
      // {
      //   name: 'Flota',
      //   url: '/fleet/list',
      //   icon: 'fa fa-truck'
      // },
      {
        name: "Combustible",
        url: "/fleet/fuel",
        icon: "fa fa-tint"
      },
      {
        name: "Estado de flota",
        url: "/fleet/status"
        // icon: 'fa fa-truck',
      },
      {
        name: "Reporte de fallas",
        url: "/fleet/incidents"
        // icon: 'icon-wrench'
      }
    ]
  },
  {
    name: "Mapa",
    url: "/tracking",
    icon: "icon-location-pin"
  }
];

export const plannerVoidRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    name: "Por aprobar",
    url: "/services/all-pending",
    icon: "icon-pin"
  },
  // {
  //   name: 'Pendientes',
  //   url: '/services/pending',
  //   icon: 'icon-pin'
  // },
  {
    title: true,
    name: "Servicios planta cliente"
  },
  {
    name: "Importaciones",
    url: "/requeriments/import/",
    icon: "icon-arrow-right-circle",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/import/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/import/assigned"
      }
    ]
  },
  {
    name: "Exportaciones",
    url: "/requeriments/export/",
    icon: "icon-globe",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/export/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/export/assigned"
      }
    ]
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/positioning/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/positioning/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/positioning/assigned"
      }
    ]
  },
  {
    name: "Reentregas",
    url: "/voids/redeliveries",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/redeliveries/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/redeliveries/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/redeliveries/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  },
  {
    title: true,
    name: ""
  },
  {
    name: "Por vencer",
    url: "/expiration",
    icon: "fa fa-ship"
  },
  {
    name: "Terminados",
    url: "/requeriments/finish",
    icon: "icon-drawer"
  },
  {
    name: "Mapa",
    url: "/tracking",
    icon: "icon-location-pin"
  }
];

export const clientRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    title: true,
    name: "MENU CLIENTES"
  },
  {
    name: "Inland",
    url: "/services",
    icon: "icon-plus",
    children: [
      {
        name: "Nuevo",
        url: "/services/new"
      }
    ]
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Nuevo",
        url: "/voids/positioning/new"
      }
    ]
  },
  {
    name: "Borradores",
    url: "/services/draft",
    icon: "icon-doc"
  },
  {
    name: "Pendientes",
    url: "/services/pending",
    icon: "icon-pin"
  },
  {
    name: "En curso",
    url: "/requeriments/in-progress",
    icon: "icon-arrow-right-circle"
  },
  {
    name: "Mapa",
    url: "/tracking",
    icon: "icon-location-pin"
  },
  {
    name: "Historial",
    url: "/requeriments/history",
    icon: "icon-drawer"
  }
  // {
  //   name: 'Global',
  //   url: '/services/all/',
  //   icon: 'icon-check'
  // }
];

export const executiveRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    title: true,
    name: "MENU EJECUTIVO"
  },
  // {
  //   name: 'Nuevo requerimiento',
  //   url: '/services/new',
  //   icon: 'icon-plus'
  // },
  {
    name: "Por aprobar",
    url: "/services/all-pending",
    icon: "icon-pin"
  },
  {
    name: "Aprobados",
    url: "/services/approved",
    icon: "icon-check"
  },
  {
    name: "Importaciones",
    url: "/requeriments/import/",
    icon: "icon-arrow-right-circle",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/import/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/import/assigned"
      }
    ]
  },
  {
    name: "Exportaciones",
    url: "/requeriments/export/",
    icon: "icon-globe",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/export/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/export/assigned"
      }
    ]
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/positioning/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/positioning/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/positioning/assigned"
      }
    ]
  },
  {
    name: "Reentregas",
    url: "/voids/redeliveries",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/redeliveries/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/redeliveries/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/redeliveries/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  }
];

export const supervisorVoidsRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Reentregas",
    url: "/voids/redeliveries",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/redeliveries/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/redeliveries/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/redeliveries/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  }
];

export const MovementSupervisorRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    name: "Movimientos Internos",
    url: "/movements/list",
    icon: "icon-grid"
  }
];

export const MechRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    name: "Reporte de fallas",
    url: "/fleet/incidents",
    icon: "icon-wrench"
  },
  {
    name: "Ordenes de Trabajo",
    icon: "icon-grid",
    children: [
      {
        name: "Correctivas",
        url: `/fleet/maintenance/list/${CORRECTIVA}`
      },
      {
        name: "Preventivas",
        url: `/fleet/maintenance/list/${PREVENTIVA}`
      }
    ]
  }
];

export const MaintenancePlannerRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    name: "Ordenes de Trabajo",
    icon: "icon-grid",
    children: [
      {
        name: "Correctivas",
        url: `/fleet/maintenance/list/${CORRECTIVA}`
      },
      {
        name: "Preventivas",
        url: `/fleet/maintenance/list/${PREVENTIVA}`
      }
    ]
  }
];

export const AdministrativeRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    name: "Variable",
    icon: "fa fa-money",
    children: [
      {
        name: "Pago de variable",
        url: "/payments"
      },
      {
        name: "Tarifario",
        url: "/rates"
      }
    ]
  },
  {
    name: "Vencimientos",
    icon: "icon-grid",
    children: [
      {
        name: "Choferes",
        url: "/expirated/users"
      },
      {
        name: "Flota",
        url: "/expirated/trucks"
      }
    ]
  },
  {
    name: "Gestor de zonas",
    url: "/zones",
    icon: "icon-grid",
    children: [
      {
        name: "Zonas",
        url: "/zones/list",
        icon: "fa fa-map-o"
      }
    ]
  }
];

export const FuelProviderRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    name: "Combustible",
    url: "/fleet/fuel",
    icon: "fa fa-tint"
  }
];

export const ProviderRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    name: "Asistencia",
    url: "/assistance",
    icon: "fa fa-calendar-plus-o",
    children: [
      {
        name: "Registro diario",
        url: "/assistance/list"
      },
      {
        name: "Reporte mensual",
        url: "/assistance/report"
      }
    ]
  },
  {
    name: "Pre-Liquidación",
    url: "/payments",
    icon: "fa fa-money"
  },
  {
    name: "Liquidación",
    url: "/liquidacion/list",
    icon: "fa fa-money"
  }
];

export const CCTV = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
    }
  },
  {
    title: true,
    name: "Servicios planta cliente"
  },
  {
    name: "Importaciones",
    url: "/requeriments/import/",
    icon: "icon-arrow-right-circle",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/import/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/import/assigned"
      }
    ]
  },
  {
    name: "Exportaciones",
    url: "/requeriments/export/",
    icon: "icon-globe",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/export/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/export/assigned"
      }
    ]
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/positioning/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/positioning/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/positioning/assigned"
      }
    ]
  },
  {
    name: "Reentregas",
    url: "/voids/redeliveries",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/redeliveries/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/redeliveries/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/redeliveries/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  },
  {
    name: "Terminados",
    url: "/requeriments/finish",
    icon: "icon-drawer"
  },
  {
    name: "Mapa",
    url: "/tracking",
    icon: "icon-location-pin"
  }
];

export const accountExecutiveRoutes = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary"
      // text: 'NEW'
    }
  },
  {
    title: true,
    name: "MENU CLIENTES"
  },
  {
    name: "Inland",
    url: "/services",
    icon: "icon-plus",
    children: [
      {
        name: "Nuevo",
        url: "/services/new"
      }
    ]
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Nuevo",
        url: "/voids/positioning/new"
      }
    ]
  },
  {
    name: "Borradores",
    url: "/services/draft",
    icon: "icon-doc"
  },
  {
    name: "Pendientes",
    url: "/services/pending",
    icon: "icon-pin"
  },
  {
    title: true,
    name: "Servicios planta cliente"
  },
  {
    name: "Importaciones",
    url: "/requeriments/import/",
    icon: "icon-arrow-right-circle",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/import/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/import/assigned"
      }
    ]
  },
  {
    name: "Exportaciones",
    url: "/requeriments/export/",
    icon: "icon-globe",
    children: [
      {
        name: "Por asignar",
        url: "/requeriments/export/unassigned"
      },
      {
        name: "Asignados",
        url: "/requeriments/export/assigned"
      }
    ]
  },
  {
    title: true,
    name: "Traslado vacíos"
  },
  {
    name: "Posicionamientos",
    url: "/voids/positioning",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/positioning/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/positioning/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/positioning/assigned"
      }
    ]
  },
  {
    name: "Devoluciones",
    url: "/voids/devolutions",
    icon: "icon-grid",
    children: [
      {
        name: "Por aprobar",
        url: "/voids/devolutions/unapproved"
      },
      {
        name: "Por asignar",
        url: "/voids/devolutions/unassigned"
      },
      {
        name: "Asignados",
        url: "/voids/devolutions/assigned"
      }
    ]
  },
  {
    title: true,
    name: ""
  },
  {
    name: "Terminados",
    url: "/requeriments/finish",
    icon: "icon-drawer"
  }
];
